<template>
  <div class="emoticon-bubble">
    <svg viewBox="0 0 20 36" class="front" width="20">
      <path class="bubble-border"
            :fill="color" :stroke="color" d="M20,2C11,2,3.7,8.8,3.7,17.1c0,3.4,1.2,6.7,3.4,9.3c-0.5,2.8-2.4,5-5.1,5.9c-0.7,0.2-1,0.9-0.8,1.6
		c0.2,0.5,0.7,0.9,1.2,0.9c4.1,0.1,8.1-1.2,11.3-3.7c2,0.8,3.6,1,6.3,1"/>
    </svg>
    <div class="bubble-body"
         :style="{background: color}">
      <div class="bubble-content">
        <div class="emoticon">
          <img v-if="icon.indexOf(':') === 0" :src="'emoticon/' + icon.slice(1) + '.svg'" width="26">
          <v-color-icon v-else-if="icon === 'check'" name="check" size="26" fill="white"></v-color-icon>
          <v-color-icon v-else-if="icon === 'close'" name="close" size="26" fill="white"></v-color-icon>
          <span v-else class="text">{{ icon }}</span>
        </div>
      </div>
    </div>

    <svg viewBox="20 0 18 36" class="tail" width="18">
      <path class="bubble-border"
            :fill="color" :stroke="color" d="M20,32c9,0,15.7-6.6,15.7-14.9S28.3,2,19.3,2"/>
    </svg>
  </div>
</template>

<script>
export default {
  props: { 'icon': {} },
  computed: {
    color () {
      if (this.icon === 'check') {
        return '#48C774'
      }
      if (this.icon === 'close') {
        return '#FF3860'
      }
      return 'white'
    }
  }
}
</script>

<style lang="stylus" scoped>

.emoticon-bubble {
  position: relative;
  height 36px
  display flex
  align-items center
  border-radius 30px

  &:before {
    content ''
    position absolute
    left 3px
    right 3px
    top 3px
    bottom 3px
    border-radius 30px
    box-shadow -2px 1px 11px 0px rgba(0, 0, 0, .1)
    z-index 0
    background transparent
  }

  .front, .tail {
    position relative
    z-index 1
    flex-shrink 0
  }
}

.bubble-border {
  stroke-width 2px
  z-index 1
  position relative
}

.bubble-content {
  margin: 3px -16px;
  text-align: center;
  color white;
  border-radius: 30px
  padding 0 5px
  height: 26px;
  overflow: hidden;
  transition-delay 1s

  .text {
    color $dark
  }
}

.bubble-body {
  box-sizing content-box
  height 32px
  margin 0 -1px
  transform translateY(-1px)
  z-index 2
  flex-shrink 0
}

@keyframes wrench {
  0% {
    transform: rotate(-5deg);
  }

  50% {
    transform: rotate(5deg);
  }

  100% {
    transform: rotate(-5deg);
  }
}
</style>
